module.exports = __webpack_public_path__ + "assets/img/11_665_big.83018d7d.jpg";